import { Location, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  DOCUMENT
} from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { SameUrlTraversalTracker } from './shared/utils/same-url-traversal';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
// import { Location } from '@angular/common';
import { ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isSupported } from 'firebase/messaging';
import * as moment from 'moment-timezone';
import { environment } from '../environments/environment';
import { NavbarComponent } from './components/navbar/navbar.component';
import { DeviceType } from './core/enum/device-type.enum';
import { PushNotificationService } from './core/services/api/push-notification.service';
import { StorageService } from './core/services/storage.service';
// import { Redirect } from './core/models/redirect/redirect';
// import { RedirectList } from './core/services/redirect-list';
import { AuthService } from './core/services/auth/auth.service';
import { GtmDataLayerService } from './core/services/gtm-data-layer.service';
import { StatusCodeResponseService } from './core/services/status-code-response.service';
import { WindowReferenceService } from './core/services/window-reference.service';
import { HeaderService } from './shared/services/header/header.service';
import { ToastService } from './core/services/toast.service';
import { PostMessageService } from './core/services/post-message.service';
// import { LoggingService } from './core/services/logging.service';
import { SharedModalService } from './shared/shared-modal/shared-modal.service';
import { ContactFormModalComponent } from './pages/support-button/contact-form/contact-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SuccessModalComponent } from './pages/support-button/success-modal/success-modal.component';
import { CampaignService } from './core/services/api/campaign.service';
import { AiChatbotModalComponent } from './shared/components/ai-chatbot-modal/ai-chatbot-modal.component';
import { PendingVoteModalComponent } from './shared/components/pending-vote-modal/pending-vote-modal.component';
import { CorporateActionService } from './core/services/api/mysec/corporate-action.service';
import { PostLoginInterruptService } from './core/services/post-login-interrupt/post-login-interrupt.service';
import {
  INTERRUPT_PRIORITY,
  PENDING_VOTE_INTERRUPT_KEY,
  PLATFORM_TERMS_REACCEPTANCE_INTERRUPT_KEY,
  PROFILE_REFRESH_INTERRUPT_KEY,
  PROFILE_REFRESH_LANDING,
} from './core/services/post-login-interrupt/post-login-interrupt.model';
import { PlatformTermsGateService } from './core/services/post-login-interrupt/platform-terms-gate.service';
import { AccountService } from './core/services/api/account.service';
import { ForceUpdateMessageComponent } from './pages/login/force-update-message/force-update-message.component';
import { CampaignStatus } from './core/enum/campaign-status.enum';
import { take, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
// var didScroll;
let lastScrollTop = 0;
let delta = 5;
let isVisible = false;
// declare let fbq, gtag: Function;

@Component({
    selector: '[app-root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  campaignCompanyName: string = '';
  @ViewChild(NavbarComponent) navBarComponent: NavbarComponent;
  @ViewChild('questionBox', { static: false }) questionBox: ElementRef;

  private window;
  private _router: Subscription;
  showScrollUp = false;
  deviceType = DeviceType.Web;
  isExpandFooter = false;
  launcherExist: any;
  campaignRes: any;
  showUI = true;
  showScheduleCallButton: boolean = true;
  foundersUrl: string | null = null;
  foundersUrlTitle: string;
  public showQuestionContent = false;
  public isCampaignSuccessfullyFunded: boolean | null = null;
  isToastShowing = false;

  toggleQuestionBox(): void {
    this.showQuestionContent = !this.showQuestionContent;
  }
  private loadFounderUrl(): void {
    this.isCampaignSuccessfullyFunded = null;
    const urlParts = this.router.url.split('/');
    const slug = urlParts.length >= 3 ? urlParts[2] : null;

    if (!slug) {
      this.toastService.show(this.translate.instant('toast.campaignNotFound'));
      return;
    }

    this.campaignService.getCampaign(slug).subscribe({
      next: (campaignRes: any) => {
        this.campaignRes = campaignRes;
        this.isCampaignSuccessfullyFunded = campaignRes?.campaignStatus === CampaignStatus.Success;
        if (this.isCampaignSuccessfullyFunded) {
          this.showQuestionContent = false;
        }
        const campaignId = campaignRes?.id;
        this.campaignCompanyName = campaignRes?.company?.name
          ? this.translate.instant('app.askCompany', { company: campaignRes.company.name })
          : this.translate.instant('app.askAthletesPlaceholder');
        if (!campaignId) {
          this.toastService.show(this.translate.instant('toast.invalidCampaignData'));
          return;
        }
        this.campaignService.getCampaignInfo(campaignId).subscribe({
          next: (infoRes: any) => {
            this.foundersUrl = infoRes?.foundersUrl || null;
            this.foundersUrlTitle = infoRes?.foundersUrlTitle;
            this.showScheduleCallButton = !!this.foundersUrl;
          },
          error: () => {
            this.toastService.show(this.translate.instant('toast.failedToGetCampaignInfo'));
          },
        });
      },
      error: () => {
        this.isCampaignSuccessfullyFunded = false;
      },
    });
  }
  scheduleCall(): void {
    if (this.foundersUrl) {
      window.open(this.foundersUrl, '_blank');
    } else {
      this.toastService.show(this.translate.instant('toast.scheduleCallNotAvailable'));
    }
  }

  joinWhatsAppGroup(): void {
    if (this.campaignRes?.whatappsGroupLink) {
      window.open(this.campaignRes.whatappsGroupLink, '_blank');
    } else {
      if (!this.isToastShowing) {
        this.isToastShowing = true;
        this.toastService.show(this.translate.instant('toast.whatsappLinkNotAvailable'));

        setTimeout(() => {
          this.isToastShowing = false;
        }, 2000);
      }
    }
  }

  openAthletesSupport(): void {
    this.showQuestionContent = false;
    const segments = this.router.url.split('?')[0].split('/');
    const slug = segments.length >= 3 ? segments[2] : null;

    if (!slug) {
      this.toastService.show(this.translate.instant('toast.campaignNotFound'));
      return;
    }

    this.router.navigate([`/equity/${slug}`], {
      queryParams: { selectedTab: 4 },
      queryParamsHandling: 'merge',
      skipLocationChange: false,
    });
  }

  trackChatbotSession(chatbotWindow: Window) {
    const startTime = Date.now();

    const interval = setInterval(() => {
      if (chatbotWindow.closed) {
        const duration = Math.floor((Date.now() - startTime) / 1000);

        this._gtmDataLayerService.logEvent('Chatbot_Returned', {
          campaign_id: this.campaignRes?.id,
          duration_seconds: duration,
        });

        console.log('User returned. Time spent:', duration, 'seconds');

        clearInterval(interval);
      }
    }, 1000);
  }

  openAIChatbot(): void {
    this.showQuestionContent = false;
    if (!this.campaignRes?.chatbotUrl) {
      this.toastService.show(this.translate.instant('toast.chatbotNotAvailable'));
      return;
    }

    const modalRef = this.modalService.open(AiChatbotModalComponent, {
      centered: true,
      windowClass: 'ai-chatbot-modal',
    });

    modalRef.componentInstance.campaignName = this.campaignRes?.name || 'Campaign';

    modalRef.result.then((result) => {
      if (result === 'continue') {
        this._gtmDataLayerService.logEvent('Chatbot_Clicked', {
          campaign_id: this.campaignRes?.id,
          company_name: this.campaignRes?.name,
        });

        const chatbotWindow = window.open(this.campaignRes.chatbotUrl, '_blank');

        if (!chatbotWindow) {
          console.warn('Popup blocked');
          return;
        }

        this._gtmDataLayerService.logEvent('Chatbot_Opened', {
          campaign_id: this.campaignRes?.id,
        });

        this.trackChatbotSession(chatbotWindow);
      }
    });
  }

  openContactFormModal(): void {
    this.showQuestionContent = false;
    this.sharedModalService
      .open(ContactFormModalComponent, {
        title: 'Need Help? Contact Us!',
      })
      .then((result) => {
        if (result) {
          this.sharedModalService.open(SuccessModalComponent);
        }
      });
  }

  DeviceType: typeof DeviceType = DeviceType;

  constructor(
    private modalService: NgbModal,
    private readonly renderer: Renderer2,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly windowRef: WindowReferenceService,
    private readonly element: ElementRef,
    public readonly location: Location,
    public readonly translate: TranslateService,
    private readonly storageService: StorageService,
    private readonly authService: AuthService,
    private readonly pushNotificationService: PushNotificationService,
    @Inject(DOCUMENT) private readonly document: any,
    @Inject(PLATFORM_ID) private readonly platform: Object,
    private readonly activatedRoute: ActivatedRoute,
    private readonly headerService: HeaderService,
    private readonly statusCodeResponseService: StatusCodeResponseService,
    private readonly _gtmDataLayerService: GtmDataLayerService,
    private readonly toastService: ToastService,
    private readonly campaignService: CampaignService,
    private readonly postMessageService: PostMessageService,
    // private loggingService: LoggingService
    private readonly sharedModalService: SharedModalService,
    private readonly corporateActionService: CorporateActionService,
    private readonly interruptService: PostLoginInterruptService,
    private readonly accountService: AccountService,
    private readonly platformTermsGate: PlatformTermsGateService,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      // INC-327: was `modalService.dismissAll()`, which also wiped the post-login
      // interrupts — and not only on later navigation. The FIRST NavigationEnd lands
      // after the login popup has already opened, so this killed it on first paint.
      // Every other modal is still dismissed exactly as before; only the queue's own
      // modal is spared, because the queue owns its lifetime.
      this.interruptService.dismissOtherModals();
      this.showQuestionContent = false;
    });
    this.window = windowRef.nativeWindow;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    const clickedInsideBox = this.questionBox?.nativeElement.contains(target);
    const clickedButton = target.closest('.pitchin-icon-quetions-mark');
    if (!clickedInsideBox && !clickedButton && this.showQuestionContent) {
      this.showQuestionContent = false;
    }
  }

  @HostListener('window:scroll')
  hasScrolled() {
    let st = window.pageYOffset;
    this.showScrollUp = st > 0;

    let launcher = document.getElementById('launcher');

    if (launcher) {
      launcher.style.bottom =
        this.showScrollUp && this.isExpandFooter && screen.width < 768 ? '89px' : '0px';
    }
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    let navbar = document.getElementsByTagName('header')[0];
    let campaignNavbar = document.getElementById('tabList');

    // If they scrolled down and are past the navbar, add class .headroom--unpinned.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && this.getPosition(navbar) <= 0) {
      // Scroll Down
      if (navbar.classList.contains('headroom--pinned')) {
        navbar.classList.remove('headroom--pinned');
        navbar.classList.add('headroom--unpinned');
      }

      this.navBarComponent.closeDropdown();
      // $('.navbar.headroom--pinned').removeClass('headroom--pinned').addClass('headroom--unpinned');
    } else {
      // Scroll Up
      //  $(window).height()
      if (st + window.innerHeight < document.body.scrollHeight) {
        // $('.navbar.headroom--unpinned').removeClass('headroom--unpinned').addClass('headroom--pinned');
        // When the campaignNavbar is visible in the viewport, avoid the navbar to be pinned
        // Force to pin when it hits the top
        if (
          st <= delta ||
          (!this.isElementVisibleInViewport(campaignNavbar) &&
            navbar.classList.contains('headroom--unpinned'))
        ) {
          navbar.classList.remove('headroom--unpinned');
          navbar.classList.add('headroom--pinned');
        } else if (
          this.isElementVisibleInViewport(campaignNavbar) &&
          navbar.classList.contains('headroom--pinned')
        ) {
          navbar.classList.remove('headroom--pinned');
          navbar.classList.add('headroom--unpinned');
        }
        // Force to pin when it hits the top
        // else if (st <= delta) {
        //     navbar.classList.remove('headroom--unpinned');
        //     navbar.classList.add('headroom--pinned');
        // }
      }
    }

    lastScrollTop = st;
  }

  public isEquityCampaignPage = false;
  public isCampaignSummaryPage = false;

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      // check the showScheduleCallButtone to show or hide the button based on the campaign
      this.isEquityCampaignPage = this.router.url.startsWith('/equity/');
      if (this.isEquityCampaignPage) {
        this.loadFounderUrl();
      }
      // INC-329: re-check on every navigation (incl. the post-login redirect) so the
      // interrupts appear right after the investor lands, without needing a manual page
      // refresh. The flag inside dedupes to once per authenticated session and re-arms on
      // logout.
      this.maybeRaisePostLoginInterrupts();
      // campaign-summary has its own fixed mobile bottom bar (invest CTAs) — the
      // scroll-to-top FAB sits at the same bottom-right corner and overlaps it.
      this.isCampaignSummaryPage = this.router.url.startsWith('/campaign-summary/');
      // Re-check the pending-vote popup on subsequent navigations (without restarting the full interrupt round).
      this.maybeCheckPendingVote();
      // The terms gate is exempt while the user is reading the terms page; this re-raises it
      // once they leave, past the once-per-session latch above.
      this.platformTermsGate.onNavigation();
    });

    this.initNavigation();
    this.initLanguage();
    this.setHeaderTag();

    if (isPlatformBrowser(this.platform)) {
      this.hasScrolled();
      this.initDevice();
      this.initTimezone();
      this.initGoogleTag();
      this.maybeRaisePostLoginInterrupts();
      this.maybeCheckPendingVote();
    }

    // now will be handle from cloudfare, but remain the code for future used
    // this.initRouteCheck();
    this.syncLocalStorageWithTcf();
  }

  syncLocalStorageWithTcf() {
    this.postMessageService.syncLocalStorage();
  }

  // INC-329 — THE one place post-login interrupts are raised, once per authenticated
  // session. Re-arms when the user is no longer authenticated (logout / before login) so
  // everything is offered again on the next login.
  //
  // Before this story the two interrupts were raised at different lifecycle moments — the
  // re-KYC nudge off the login response while the investor was still on the login screen,
  // the pending vote only on NavigationEnd. An open nudge's backdrop blocks navigation, so
  // they could never be queued together and INC-280's unified frame was unreachable on the
  // ordinary login path. Both are now asked here, after the investor has landed.
  /**
   * Which user we have already raised interrupts for — deliberately the user id, NOT a bare
   * "done" boolean.
   *
   * `authService.isAuthenticated()` reads localStorage, which survives a page load and is shared
   * across tabs. A boolean latch is therefore wrong on any path where the session CHANGES without
   * passing through a logged-out state — login-on-behalf being the real one: the app bootstraps on
   * `/redirect-login` while the previous session's storage is still present, so the latch would be
   * set for the OUTGOING user and the impersonated investor's compliance gate would never be
   * raised at all. Keying on the user id makes a session swap re-arm the trigger structurally.
   */
  private interruptsRaisedForUserId: string | null = null;

  /**
   * Bumped every time a fresh raise round starts below. {@link sessionGuard} checks this
   * alongside the user id: the id alone cannot tell a same-user RELOGIN apart from the session
   * that was live when an in-flight request was issued, since it is identical either way.
   * Without it, a response landing after logout-then-login-as-the-same-user would act on the
   * NEW round — closing it early with stale data, or queueing something its own check has not
   * reported yet.
   */
  private sessionGeneration = 0;

  private maybeRaisePostLoginInterrupts(): void {
    if (!isPlatformBrowser(this.platform)) {
      return;
    }
    if (!this.authService.isAuthenticated()) {
      // A session ended under us. Drop anything queued or remembered, once, so nothing from the
      // previous user can surface on a logged-out page or leak into the next session.
      if (this.interruptsRaisedForUserId !== null) {
        this.interruptsRaisedForUserId = null;
        this.interruptService.reset();
        this.platformTermsGate.reset();
      }
      return;
    }

    const userId = this.currentUserId();
    if (this.interruptsRaisedForUserId === userId) {
      return;
    }
    this.interruptsRaisedForUserId = userId;
    this.sessionGeneration++;
    const isCurrent = this.sessionGuard();

    // Open ONE collection round over every source before asking any of them. Nothing presents
    // until all have reported (or the timeout fires), so the investor never sees a single
    // card open and then get replaced by the frame as the second source lands.
    this.interruptService.beginCollection([
      PROFILE_REFRESH_INTERRUPT_KEY,
      PENDING_VOTE_INTERRUPT_KEY,
      PLATFORM_TERMS_REACCEPTANCE_INTERRUPT_KEY,
    ]);
    this.checkProfileRefresh(isCurrent);
    this.checkPendingVote(isCurrent);
    this.platformTermsGate.check(isCurrent);
  }

  private currentUserId(): string | null {
    return this.storageService.userId || null;
  }

  private maybeCheckPendingVote(): void {
    if (this.interruptsRaisedForUserId === this.currentUserId()) {
      this.checkPendingVote(this.sessionGuard());
    }
  }

  /**
   * A guard bound to the session as it is right now: true only while that same login (same user,
   * same generation) is still the live one.
   *
   * Every source is asynchronous, so a response can land after the investor has logged out, after
   * login-on-behalf has swapped the token underneath, or after a same-user re-login. Enqueuing then
   * would show the previous session's card — with their name on it — to whoever is now looking at
   * the screen. Reporting then would be just as wrong: it would close half of the NEW round. Each
   * async callback checks the guard it was handed before touching the interrupt queue.
   */
  private sessionGuard(): () => boolean {
    const userId = this.currentUserId();
    const generation = this.sessionGeneration;
    return () =>
      this.authService.isAuthenticated() &&
      this.currentUserId() === userId &&
      this.sessionGeneration === generation;
  }

  /**
   * INC-329 — the re-KYC / profile-refresh gate, read from the profile endpoint rather than
   * the login response (option (b)). That endpoint is called on every app init, so the flag
   * survives a page refresh and an already-authenticated returning session, which carrying
   * it in frontend state could not.
   *
   * `profile()` reuses `currentUser` when it is already populated. Note it often is NOT on the
   * ordinary login path: `checkSignUpFlow` fires `profile(true)` and navigates synchronously in the
   * same handler, so this usually lands while `currentUser` is still null and issues its own
   * request. That is a duplicate round-trip, not a correctness problem — both responses carry the
   * same profile.
   */
  private checkProfileRefresh(isCurrent: () => boolean): void {
    this.accountService
      .profile()
      .pipe(
        take(1),
        catchError(() => of(null)),
      )
      .subscribe((profile) => {
        if (!isCurrent()) {
          return;
        }
        if (!profile?.isProfileRefreshRequired) {
          // Report either way: a source with nothing to add still has to close its half of the
          // round, or presentation would wait for the timeout every time.
          this.interruptService.sourceReported(PROFILE_REFRESH_INTERRUPT_KEY);
          return;
        }
        this.enqueueProfileRefresh(profile.fullName, isCurrent);
      });
  }

  /**
   * Resolved through `translate.get` rather than `translate.instant`.
   *
   * These strings used to be read in `LoginComponent`, long after bootstrap. They are now read as
   * soon as the profile call returns after app init, which races the ngx-translate loader started
   * by `initLanguage()` — and `instant()` losing that race returns the raw KEY, so the frame's
   * cover would render `postLoginInterrupts.profileRefresh.label` on screen. This feature has
   * already shipped one placeholder bug that only appeared at render; not repeating it.
   *
   * `get` emits synchronously once translations are loaded, so the common path is unchanged. If it
   * fails outright we fall back to `instant()` — an ugly label is bad, but silently dropping a
   * compliance gate is worse.
   */
  private enqueueProfileRefresh(fullName: string, isCurrent: () => boolean): void {
    const labelKey = 'postLoginInterrupts.profileRefresh.label';
    const summaryKey = 'postLoginInterrupts.profileRefresh.summary';

    this.translate
      .get([labelKey, summaryKey])
      .pipe(
        take(1),
        catchError(() =>
          of({
            [labelKey]: this.translate.instant(labelKey),
            [summaryKey]: this.translate.instant(summaryKey),
          }),
        ),
      )
      .subscribe((copy) => {
        if (!isCurrent()) {
          return;
        }
        this.interruptService.enqueue({
          key: PROFILE_REFRESH_INTERRUPT_KEY,
          kind: 'gate',
          priority: INTERRUPT_PRIORITY.complianceGate,
          label: copy[labelKey],
          summary: copy[summaryKey],
          component: ForceUpdateMessageComponent,
          inputs: { name: fullName },
          modalOptions: {
            centered: true,
            windowClass: 'profile-refresh-nudge-modal',
            ariaLabelledBy: 'profile-refresh-title',
          },
          // "Verify now". The investor has already landed, so returnUrl is simply where
          // they are — not, as before, a post-login destination deferred until the nudge
          // was answered. The review-and-attest screen guards it before forwarding.
          onResolve: () => {
            this.router
              .navigate(PROFILE_REFRESH_LANDING, {
                queryParams: { required: '', returnUrl: this.profileRefreshReturnUrl() },
              })
              .catch((err) => {
                console.error('fail to navigate to profile refresh landing:' + err);
              });
          },
          // "Remind me later" / backdrop / Esc. Nothing to finalise any more — the login
          // navigation already happened, which is the whole point of moving the trigger.
          // The dismissal is remembered for the session (see InterruptQueue's store), so a
          // page refresh does not nag; the next LOGIN raises it again.
        });
        this.interruptService.sourceReported(PROFILE_REFRESH_INTERRUPT_KEY);
      });
  }

  /**
   * Where "Verify now" should send the investor back to afterwards. Normally wherever they already
   * are — but never the review-and-attest screen itself, which is reachable here on a hard refresh
   * of that page and would otherwise return them to where they started.
   */
  private profileRefreshReturnUrl(): string {
    const here = this.router.url;
    return here.startsWith(PROFILE_REFRESH_LANDING[0]) ? '/' : here;
  }

  private checkPendingVote(isCurrent: () => boolean): void {
    if (!this.authService.isAuthenticated()) {
      this.interruptService.sourceReported(PENDING_VOTE_INTERRUPT_KEY);
      return;
    }

    this.corporateActionService
      .getPendingVote()
      .pipe(
        take(1),
        catchError(() => of(null)),
      )
      .subscribe((pending) => {
        if (!isCurrent()) {
          return;
        }
        if (pending) {
          // INC-327: through the queue, so it can be ranked behind the compliance gate
          // instead of racing it. As the only pending interrupt it still opens as its
          // own centered modal — the render is unchanged.
          const labelKey = 'postLoginInterrupts.pendingVote.label';
          const summaryKey = 'postLoginInterrupts.pendingVote.summary';

          this.translate
            .get([labelKey, summaryKey], { company: pending.companyName, type: pending.type })
            .pipe(
              take(1),
              catchError(() =>
                of({
                  [labelKey]: this.translate.instant(labelKey),
                  [summaryKey]: this.translate.instant(summaryKey, { company: pending.companyName, type: pending.type }),
                }),
              ),
            )
            .subscribe((copy) => {
              if (!isCurrent()) {
                return;
              }
              this.interruptService.enqueue({
                key: PENDING_VOTE_INTERRUPT_KEY,
                kind: 'dismissible',
                priority: INTERRUPT_PRIORITY.dismissible,
                label: copy[labelKey],
                summary: copy[summaryKey],
                component: PendingVoteModalComponent,
                inputs: { pendingVote: pending },
                modalOptions: { centered: true },
              });
            });
        }
        this.interruptService.sourceReported(PENDING_VOTE_INTERRUPT_KEY);
      });
  }

  isElementVisibleInViewport(el) {
    if (!el) return false;

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.boundingClientRect.top <= 5) {
          // Element is now sticks on the top
          isVisible = true;
        } else {
          isVisible = false;
        }
      });
    }, options);

    observer.observe(el);

    return isVisible;
  }

  getPosition(element) {
    if (!element) return 0;

    const rect = element?.getBoundingClientRect();
    return rect.top;
  }

  initNavigation() {
    let navbar: HTMLElement = this.element.nativeElement.children[1].children[0];

    // FRC-749: a BACK/FORWARD onto the URL already showing (the investor bottom sheet's own history
    // entry) changed nothing on screen — no scroll-to-top, no duplicate GTM page_view.
    const sameUrlTraversals = new SameUrlTraversalTracker();

    this._router = this.router.events
      .pipe(filter((event) => !sameUrlTraversals.check(event) && event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Will update the page title (based on what set in `app.routing.ts`)
        // Unless being overrided by individual page
        this.setPageTitle();

        if (isPlatformBrowser(this.platform)) {
          this.showUI = location.pathname != '/redirect-login';
          this.isExpandFooter = this.activatedRoute.root.firstChild.snapshot.data.expandFooter;

          if (window.outerWidth > 991) window.document.children[0].scrollTop = 0;
          else window.document.activeElement.scrollTop = 0;

          // Log all the virtual PageView for all pages, except for those that handle `pageTitle`
          // outside from `app.routing.ts`, as it will be log separately
          this.logPageView();
        }

        this.renderer.listen('window', 'scroll', (event) => {
          const number = window.scrollY;
          if (number > 150 || window.pageYOffset > 150) {
            // add logic
            navbar.classList.add('headroom--not-top');
          } else {
            // remove logic
            navbar.classList.remove('headroom--not-top');
          }
        });
      });
  }

  ngOnDestroy() {
    if (this.launcherExist) clearInterval(this.launcherExist);

    this.postMessageService.cleanUp();
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platform)) {
      this.initFirebase();
    }
  }

  private initLanguage(): void {
    this.translate.addLangs(['en-US', 'zh-CN', 'ms-MY']);
    this.translate.setDefaultLang('en-US');

    // Restore persisted language preference, fallback to en-US
    let storedLang: string | null = null;
    try { storedLang = localStorage.getItem('pitchin_lang'); } catch { /* noop */ }
    const lang = (storedLang && ['en-US', 'zh-CN', 'ms-MY'].includes(storedLang))
      ? storedLang
      : 'en-US';
    this.translate.use(lang);
  }

  switchLanguage(lang: string): void {
    this.translate.use(lang);
    try { localStorage.setItem('pitchin_lang', lang); } catch { /* noop */ }
  }

  private initDevice(): void {
    if (!this.storageService.deviceId)
      this.storageService.deviceId = Math.random().toString(36).substr(2);

    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) this.deviceType = DeviceType.iOS;
    else if (/Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
      this.deviceType = DeviceType.Android;
  }

  private initTimezone(): void {
    moment.tz.setDefault(this.storageService.timeZone || moment.tz.guess());
  }

  private async initFirebase() {
    // reference: https://stackoverflow.com/questions/56215286/firebase-messaging-is-not-supported-in-your-browser-how-to-solve-this
    const isDeviceSupported = await isSupported();

    if (isDeviceSupported) {
      try {
        this.pushNotificationService.requestPermission();
        this.pushNotificationService.listen();
      } catch (e) {
        console.error(e);
      }
    }
  }

  scrollUp() {
    window.scroll({ top: 0, behavior: 'smooth' });
  }

  // initRouteCheck() {
  //     this.router.events.subscribe((event: Event) => {
  //         if (event instanceof NavigationStart) {
  //             let redirects: Redirect[] = RedirectList;
  //             redirects.forEach(redirect => {
  //                 if (event.url == redirect.fromUrl) {
  //                     this.router.navigate([redirect.toUrl]);
  //                 }

  //                 if (redirect.slugs && redirect.slugs.length > 0) {
  //                     let urls = event.url.toString().split("/").filter((element): element is string => {
  //                         return element !== null && element !== "";
  //                     });

  //                     if (('/' + urls[0] + '/' == redirect.fromUrl) && redirect.slugs.includes(urls[1])) {
  //                         let redirectUrl = redirect.toUrl + urls[1];
  //                         this.statusCodeResponseService.setRedirect(redirectUrl);
  //                         this.router.navigate([redirectUrl]);
  //                     }
  //                 }
  //             });
  //         }

  //         if (event instanceof NavigationError) {
  //             console.log(event.error);
  //         }
  //     });
  // }

  setHeaderTag() {
    let logoUrl = `${environment.baseUrl}/assets/img/logo/pitchIN_share_image.png`;
    this.headerService.updatePropertyTag('og:image', logoUrl);
    this.headerService.updateNameTag('twitter:image', logoUrl);
    this.headerService.updateNameTag('image', logoUrl);

    if (environment.environment != 'PRODUCTION') {
      if (!!this.headerService.getTag("content='noindex'"))
        this.headerService.updateNameTag('robots', 'noindex');
      else this.headerService.addTag('robots', 'noindex');

      if (!!this.headerService.getTag("content='nosnippet'"))
        this.headerService.updateNameTag('robots', 'nosnippet');
      else this.headerService.addTag('robots', 'nosnippet');
    } else {
      this.headerService.removeTag("name='robots'");
    }
  }

  initGoogleTag() {
    if (environment.environment !== 'PRODUCTION' || !environment.googleTagId) return;

    const dataLayerName = 'dataLayer';
    const w = this.window as any;
    w[dataLayerName] = w[dataLayerName] || [];
    w[dataLayerName].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    if (!this.document.getElementById('gtm-script')) {
      const script = this.document.createElement('script');
      script.id = 'gtm-script';
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${environment.googleTagId}&l=${dataLayerName}`;
      this.document.head.appendChild(script);
    }

    if (!this.document.getElementById('gtm-noscript')) {
      const noscript = this.document.createElement('noscript');
      noscript.id = 'gtm-noscript';
      noscript.innerHTML = `
                    <iframe src="https://www.googletagmanager.com/ns.html?id=${environment.googleTagId}"
                    height="0" width="0" style="display:none;visibility:hidden"></iframe>
                `;
      this.document.body.prepend(noscript);
    }
  }

  getCurrentRouteData(route: ActivatedRouteSnapshot) {
    while (route.firstChild) {
      route = route.firstChild;
    }

    return route.data;
  }

  setPageTitle() {
    let routeData = this.getCurrentRouteData(this.route.snapshot);

    // Will update the `title` when it exists in `app.routing.ts`
    if (routeData?.title) {
      let name = () => {
        if (routeData.prependCompanyNameIntoTitle) {
          return `pitchIN | ${routeData.title}`;
        }

        return `${routeData.title} | pitchIN`;
      };

      this.headerService.setHeaderTag(name());
    }
  }

  logPageView() {
    let routeData = this.getCurrentRouteData(this.route.snapshot);

    if (routeData?.title) {
      this._gtmDataLayerService.logPageView(
        this.router.url,
        document.title,
        undefined,
        routeData.gtmContentGroup,
      );
    }
  }
}
